
import AccessibleMarker from './accessible-marker';

export default function (dynamicClassesContainer) {


    if (dynamicClassesContainer.AccessibleMarkerGroup) {
        return dynamicClassesContainer.AccessibleMarkerGroup;
    }

    class AccessibleMarkerGroup extends google.maps.OverlayView {

        constructor(markers, markerTypeInfo, map, mapData,  directionsService, directionsRenderer, locateUserCallback, mapElement) {
            super();

            this.map_ = map;
            this.directionsService_ = directionsService;
            this.directionsRenderer_ = directionsRenderer;
            this.markerTypeInfo_ = markerTypeInfo;
            this.mapData_ = mapData;

            this.markers_ = markers.map((m, i) => {
                const markerData = Object.assign({
                        map: map,
                        mapId: mapData.mapId, 
                        mapIndex: mapData.mapIndex,
                        mapLang: mapData.mapLang,

                        headingLevel: mapData.headingLevel + 1,

                        contentLabels: mapData.contentLabels, 

                        markerIndex: i,
                        markerTypeInfo: markerTypeInfo
                        
                    }, m);
                return new AccessibleMarker(markerData, map, directionsService, directionsRenderer, locateUserCallback, this);
            });

            this.headingId_ = `${mapData.mapId}-mh-${markerTypeInfo.markerTypeId}`;

            this.mapEl_ = mapElement;
           
            this.setMap(map);
        }

        renderHeading() {
            const tag = `h${this.mapData_.headingLevel}`;
            return `<${tag} id="${this.headingId_}" class="visually-hidden">${this.markerTypeInfo_.heading}</${tag}>`
        }

        getPane() {
            return this.getPanes().overlayMouseTarget;
        }

        onAdd() {

          
            this.topElement_ = document.createElement('article');
            this.topElement_.classList.add('marker-container');
        
            const listTag = this.markerTypeInfo_.is_ordered ? 'ol' : 'ul'
            this.topElement_.innerHTML = `${this.renderHeading()}
                                         <${listTag} class="custom-map-accessible-marker-list" aria-labelledby="${this.headingId_}"> 
                                            ${this.markers_.map(m => m.renderMarker()).join('')}  
                                         </${listTag}>`;

            
            this.getPane().appendChild(this.topElement_);
            this.topElement_.setAttribute('aria-labelledby', this.headingId_);

            this.markers_.forEach(m => m.postRender(this.topElement_));
            
        }


        isHorizontal() {
            return window.matchMedia('(min-width: 37.5rem)').matches;
        }

        getLatLngToDivPixel(latLng) {
            return this.getProjection().fromLatLngToDivPixel(latLng);
        }

        getContainerRect() {
            return this.mapEl_.getBoundingClientRect();
        }

        draw() {
            const containerRect = this.getContainerRect();
            const isHorizontal = this.isHorizontal();
          
            this.markers_.forEach(m => m.draw(containerRect, isHorizontal));

        }

        onRemove() {
            this.getPane().removeChild(this.topElement_);
        }
    }

    dynamicClassesContainer.AccessibleMarkerGroup = AccessibleMarkerGroup;
    return AccessibleMarkerGroup;
}
